import { useEffect } from 'react';
import { useSelector } from 'react-redux';

// This component expects 'map' (the Google Map instance)
// and 'googleMapsApi' (the window.google.maps object) as props.
const SelectedDeviceMapGoogle = ({ map, googleMapsApi }) => {
    const selectedDevicePosition = useSelector(state => {
        const selectedDeviceId = state.devices.selectedId;
        if (selectedDeviceId) {
            const position = state.positions.items[selectedDeviceId]; // Assuming items is an object keyed by deviceId
            if (position && typeof position.latitude === 'number' && typeof position.longitude === 'number') {
                return {
                    lat: position.latitude,
                    lng: position.longitude,
                };
            }
        }
        return null;
    });

    useEffect(() => {
        // Ensure map, googleMapsApi, and selectedDevicePosition are available
        if (map && googleMapsApi && selectedDevicePosition) {
            // Google Maps panTo provides a smooth transition
            map.panTo(selectedDevicePosition);

            // Optional: If you want to also adjust zoom or ensure a certain zoom level.
            // The original Mapbox code `map.flyTo({ zoom: [map.getZoom()] });` is a bit odd,
            // as it flies to the current zoom level. This effectively does nothing for zoom
            // but might have re-triggered a render or animation in Mapbox.
            // For Google Maps, if you just want to pan, `panTo` is sufficient.
            // If you want to set a specific zoom when a device is selected:
            // const desiredZoom = 15; // Or get from somewhere else
            // if (map.getZoom() !== desiredZoom) { // Only change zoom if it's different
            //    map.setZoom(desiredZoom);
            // }

            // If you want a "flyTo" like animation that includes zoom,
            // Google Maps doesn't have a direct "flyTo" like Mapbox that animates
            // both center and zoom smoothly with a curved path.
            // You can combine panTo and setZoom, or use map.moveCamera for more complex movements,
            // but it won't have the same "fly" effect.
            // For a simple pan, map.panTo is best.
        }
    }, [map, googleMapsApi, selectedDevicePosition]); // Re-run effect if these dependencies change

    return null; // This component manipulates the map directly
};

export default SelectedDeviceMapGoogle;